import React from "react";
import Page from "../Page";
import Intro from "../components/landing/Intro";
import ProdFeature from "../components/landing/ProdFeature";
import Features from "../components/landing/Features";
import Pricing from "../components/landing/Pricing";
import OurTeam from "../components/landing/OurTeam";
import Footer from "../components/landing/Footer";

const Home = () => {
  return (
    <Page>
      <Intro />
      <ProdFeature />
      <Features />
      <Pricing />
      <OurTeam />
      <Footer />
    </Page>
  );
};

export default Home;
